export default __webpack_public_path__ + "media/images/features/toyono/osaka_smart_logo-0a3807140899ee152401aad96c2032b5.png";